import { CreatePasswordVaultResponse } from "@app/model/api/passwordVault/CreatePasswordVaultResponse";

export class CreateNewVaultResponse {
    vaultEncryptionKey: string;
    vaultDataKey: string;
    serverResponse: CreatePasswordVaultResponse;
}